import { getCookieByName } from "./cookieConsent";

export const getTrafficType = () => {
  const cookieValue = getCookieByName("internal_ip");

  const isProduction = process.env.NEXT_PUBLIC_APP_ENV === "production";

  if (!isProduction || cookieValue === "true") {
    return "internal";
  } else if (cookieValue === "false") {
    return "external";
  }

  return "NA";
};
